import { TableColumn } from 'react-data-table-component';

// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  map = 'map',
  qrCode = 'qrCode',
  ticket = 'ticket',
  url = 'url',
}

// eslint-disable-next-line no-shadow
export enum FormInputName {
  eventId = 'eventId',
  sectionId = 'sectionId',
  code = 'code',
  paymentForm = 'paymentForm',
  showUserData = 'showUserData',
  minPayment = 'minPayment',
  fractionalSale = 'fractionalSale',
  fractionalAmount = 'fractionalAmount',
}

// eslint-disable-next-line no-shadow
export enum UserDataFormInputName {
  name = 'name',
  document = 'document',
  email = 'email',
  phone = 'phone',
  birthDate = 'birthDate',
  motherName = 'motherName',
}

export interface OnShouldShowModalProps {
  value: ShouldShowModal;
  newTitleModal: string | React.ReactNode;
  eventKey?: string;
}

export interface DataColumn {
  id: string;
  name: string;
}

export interface TicketDataRow {
  event: string;
  ticket: string;
  ticketDate: string;
  ticketValue: string;
  clientName: string;
  clientCPF: string;
  used: string;
}

export const ticketColumns: TableColumn<TicketDataRow>[] = [
  {
    name: 'Evento',
    selector: row => row.event,
    width: '300px',
  },
  {
    name: 'Ingresso',
    selector: row => row.ticket,
    width: '300px',
  },
  {
    name: 'Data',
    selector: row => row.ticketDate,
    width: '170px',
  },
  {
    name: 'Valor',
    selector: row => row.ticketValue,
    width: '100px',
  },
  {
    name: 'Client',
    selector: row => row.clientName,
    width: '330px',
  },
  {
    name: 'CPF',
    selector: row => row.clientCPF,
    width: '150px',
  },
  {
    name: 'Utilizado',
    selector: row => row.used,
    width: '170px',
  },
];
